import { render, staticRenderFns } from "./ResendExpiredInvites.vue?vue&type=template&id=ee3ce4a4"
import script from "./ResendExpiredInvites.vue?vue&type=script&lang=js"
export * from "./ResendExpiredInvites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports